<!--
  Component: FrameworkRatingFootnote

  This component creates a footnote with text based on selected footnoteType
  and if that footnote applies for the current school.

  Props:
  - footnoteType - should be one of constants in FR_FOOTNOTE_TYPES
-->

<template>
  <div :class="['framework-rating-footnote footnote',footnoteType]">
    <template v-if="isFootnoteSuppressSE || isFootnoteSuppressSA || isFootnoteSuppressSEorSA">†An accurate rating cannot be calculated because this school did not submit student data on credit accumulation and/or student attendance.</template>
    <template v-if="isFootnoteHighOptOut">†This school received no Student Achievement rating because less than 25% of eligible students took the state exams.</template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'

import { NS_CURRENT_REPORT } from './const'

/* Hyphenated b/c these are also used in the class name for the template */
export const FR_FOOTNOTE_TYPES = Object.freeze({
  SUPPRESS_SE: 'suppress-se',
  SUPPRESS_SA: 'suppress-sa',
  SUPPRESS_SE_OR_SA: 'suppress-se-or-sa',
  OPT_OUT: 'high-opt-out-sch'
})

@Component({
  props: {
    footnoteType: String
  },
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'isSuppressSE',
      'isSuppressSA',
      'isHighOptOutSchool'
    ])
  }
})
export default class FrameworkRatingFootnote extends Vue {
  /* Getters */

  get isFootnoteHighOptOut () {
    return this.isHighOptOutSchool &&
      this.footnoteType === FR_FOOTNOTE_TYPES.OPT_OUT
  }
  get isFootnoteSuppressSE () {
    return this.isSuppressSE &&
      this.footnoteType === FR_FOOTNOTE_TYPES.SUPPRESS_SE
  }
  get isFootnoteSuppressSA () {
    return this.isSuppressSA &&
      this.footnoteType === FR_FOOTNOTE_TYPES.SUPPRESS_SA
  }
  get isFootnoteSuppressSEorSA () {
    return (this.isSuppressSA || this.isSuppressSE) &&
      this.footnoteType === FR_FOOTNOTE_TYPES.SUPPRESS_SE_OR_SA
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2017/FrameworkRatingFootnote.vue